<template>
  <div>
    <div class="media mt-5">
      <router-link :to="{ name: 'Product', params: { id: product.id } }">
        <img :src="product.image" class="img-fluid mr-3" />
      </router-link>
      <div class="media-body mt-2">
        <h5>
          <router-link :to="{ name: 'Product', params: { id: product.id } }">{{ product.name }}</router-link>
        </h5>
        <s>&#8358;{{ addComma(product.prevPrice) }}</s>
        <h6>&#8358;{{ addComma(product.price) }}</h6>
        <button
          class="btn btn-outline-dark font-weight-bold mt-4"
          @click="addToCart()"
          v-if="!product.selected"
        >Add To Cart</button>
        <router-link
          v-if="product.selected"
          to="/cart"
          class="btn btn-outline-dark font-weight-bold mt-4"
        >
          <i class="fa fa-shopping-bag mr-2" aria-hidden="true"></i>View
          cart
        </router-link>
      </div>
    </div>
    <transition name="fade">
      <Loading v-if="isloading" />
    </transition>
  </div>
</template>

<script>
import Loading from "./Loading";
export default {
  name: "ProductCard",
  components: {
    Loading
  },
  computed: {
    isloading() {
      return this.$store.state.isloading;
    }
  },
  props: ["product"],
  data() {
    return {};
  },
  methods: {
    addToCart() {
      this.$store.state.isloading = true;
      setTimeout(() => {
        this.$store.state.isloading = false;
        this.AddToState();
      }, 2000);
    },

    AddToState: function() {
      this.$store.dispatch("addProductToCart", {
        product: this.product,
        quantity: 1
      });
    },
    addComma: function(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};
</script>

<style></style>
